import { Injectable } from '@angular/core';
import { environment } from 'src/environments/environment';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HttpErrorResponse,
} from '@angular/common/http';
import {
  BehaviorSubject,
  catchError,
  filter,
  Observable,
  switchMap,
  take,
  throwError,
} from 'rxjs';
import { AuthService } from '../services/auth.service';
import { SessionStorageService } from '../services/session-storage.service';
import { Location } from '@angular/common';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  private isRefreshing = false;
  private registerUrl = `${environment.apiurl}/login`;
  private refreshTokenSubject: BehaviorSubject<any> = new BehaviorSubject<any>(
    null
  );
  constructor(private sessionStorageService: SessionStorageService, private authService: AuthService, private location: Location) {}

  intercept(
    request: HttpRequest<unknown>,
    next: HttpHandler
  ): Observable<HttpEvent<unknown>> {
    const token = this.sessionStorageService.getItem('token');
    if (token && request.url.search('refresh-token')  === -1) {
      request = request.clone({
        setHeaders: {
          authorization: `Bearer ${token}`,
        },
      });
    }

    return next.handle(request).pipe(
      catchError((err: HttpErrorResponse) => {
        if (err.status === 401) {
          return this.handle401Error(request, next);
        }

        return throwError(() => err);
      })
    );
  }

  private handle401Error(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      const refreshToken = this.sessionStorageService.getItem('refresh-token')!;

      if (refreshToken) {
        return this.authService.refreshToken(refreshToken).pipe(
          switchMap((data: any) => {
            this.sessionStorageService.updateItem('token', data.token)
            this.sessionStorageService.updateItem('refresh-token', data.refreshToken)
            const newToken = data.token;
            request = request.clone({
              setHeaders: {
                authorization: `Bearer ${newToken}`,
              },
            });
            this.isRefreshing = false;
            this.refreshTokenSubject.next(newToken);
            return next.handle(request);
          }),
          catchError((err) => {
            this.isRefreshing = false;
            window.location.href = this.registerUrl;
            this.location.replaceState('dashboard');
            window.location.reload();
            return throwError(() => err);
          })
        );
      }
    }

    return this.refreshTokenSubject.pipe(
      filter((token) => token !== null),
      take(1),
      switchMap((token: string) => {
        request = request.clone({
          setHeaders: {
            authorization: `Bearer ${token}`,
          },
        });
        return next.handle(request)
      })
    );
  }
}
